import React, { useState, useEffect } from 'react';
import MDModal from 'components/MDModal';
import "../style.css";
const Lockicon=()=>{
  return(
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 5V3C9 1.3435 7.6565 0 6 0C4.3435 0 3 1.3435 3 3V5H1.5V12H10.5V5H9ZM4 5V3C4 1.897 4.897 1 6 1C7.103 1 8 1.897 8 3V5H4Z" fill="#5D737E"/>
</svg>
  )
}
function View({ openModel, data, modelfunctionality,onclosemodel }) {
  const [formData, setFormData] = useState({
    promptName: '',
    category: '',
    subCategory: '',
    description: ''
  });

  useEffect(() => {
    if (data) {
      setFormData({
        promptName: data.title || '',
        category: data.category || '',
        subCategory: data.subCategory || '',
        description: data.description || ''
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    modelfunctionality(formData); // Pass formData to the function
  };

  return (
    <>
     {openModel &&
        <div className="modal-zz-confirm text-left"  >

          <div className="scrollable-modal-content bg-white  rounded" style={{position: "relative" }}>
            
            {data && (
              <h2 className='text-black text-left font-14'> Task: <span className='font-13'> {data.title}</span>
            </h2>
             
          )}
            <span className='crossison' onClick={onclosemodel}>X</span>
            
             
       
        <form onSubmit={handleSubmit}>
          <div className='w-100 ' style={{marginTop:"10px"}}>
            <div>
              <label className='new_dezin_label text-black '>Task Name</label>
            </div>
            <div style={{position:"relative"}}>
            <i className='lockininput'><Lockicon/></i>
              <input
              readOnly
              disabled
                type="text"
                name='promptName'
                className='w-100 selectstyle'
                value={formData.promptName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className='w-100'>
            <div>
              
              <label className='new_dezin_label text-black '>Category</label>
            </div>
            <div style={{position:"relative"}}>
               <i className='lockininput'><Lockicon/></i>
              <input
              readOnly
              disabled
                type="text"
                name='category'
                className='w-100 selectstyle'
                value={formData.category}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* <div className='w-100'>
            <div>
              <label className='new_dezin_label text-black '>Sub Category</label>
            </div>
            <div style={{position:"relative"}}>
            <i className='lockininput'><Lockicon/></i>
              <input
              readOnly
              disabled
                type="text"
                name='subCategory'
                className='w-100 selectstyle'
                value={formData.subCategory}
                onChange={handleChange}
              />
            </div>
          </div> */}

          <div className='w-100'>
            <div>
              <label className='new_dezin_label text-black '>Description</label>
            </div>
            <div style={{position:"relative"}}>
            <i className='lockininput'><Lockicon/></i>
              <textarea
              readOnly
              disabled
                rows={8}
                name='description'
                className='w-100 selectstyle'
                value={formData.description}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className='w-100 margin-top-20px'>
            <button type='submit' className='btn-newdezine'>Done</button>
          </div>
        </form>
      </div>
            </div>
              }
              </>
   
  );
}

export default View;
